import { DirectionsRenderer } from '@react-google-maps/api'
import React, { useContext, useEffect, useState } from 'react'
import { Context } from '../../contexts/Context'
const _ = require('lodash')

export default function Directions ({ origin, centersList }) {
  const { selectedClinic } = useContext(Context)
  const destination = {}
  if (!_.isEmpty(centersList)) {
    const data = centersList.find(center => center.centerId === selectedClinic).location.coordinates
    destination.lat = data[1]
    destination.lng = data[0]
  }
  const [directionsResponse, setDirectionsResponse] = useState(null)
  async function calculateRoute () {
    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService()
    const results = await directionsService.route({
      origin,
      destination,
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING
    })
    setDirectionsResponse(results)
  }

  useEffect(() => {
    if (!_.isEmpty(centersList) && selectedClinic) {
      calculateRoute()
    }
    // eslint-disable-next-line
  }, [selectedClinic])

  return (
    <>
      {centersList && selectedClinic && directionsResponse && <DirectionsRenderer
        directions={directionsResponse}
        options={{
          markerOptions: {
            icon: 'a'
          },
          polylineOptions: {
            strokeWeight: 5,
            strokeColor: '#0373fc'
          },
          preserveViewport: true
        }}
                                                              />}
    </>
  )
}
